import { Collapse } from 'antd'
import isEmpty from 'lodash/isEmpty'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { faqData, moreFaqData } from '../commonData'
import './Faq.css'

export default function Faq({ faqInfo, loanOfficerEmail, isMobile }) {
    const [displayFaqs, setDisplayFaqs] = useState([...faqData])

    useEffect(() => {
        if (faqInfo && !isEmpty(faqInfo)) {
            setDisplayFaqs(faqInfo.length > 3 ? faqInfo.slice(0, 3) : faqInfo)
        }
    }, [faqInfo])

    const [showMore, setShowMore] = useState(false)
    const [activeKeys, setActiveKeys] = useState([])

    const hideMoreButton = useMemo(() => {
        if (!faqInfo || isEmpty(faqInfo)) {
            return false
        }

        return faqInfo.length <= 3
    }, [faqInfo])

    const handleClickMoreFaqs = useCallback(() => {
        setShowMore(!showMore)

        if (!faqInfo || isEmpty(faqInfo)) {
            if (!showMore) {
                setDisplayFaqs([...faqData, ...moreFaqData])
            } else {
                setDisplayFaqs(faqData)
            }
        } else {
            if (!showMore) {
                setDisplayFaqs(faqInfo)
            } else {
                setDisplayFaqs(faqInfo.slice(0, 3))
            }
        }
    }, [faqInfo, showMore])

    const handleFaqChange = useCallback((newActiveKeys) => {
        setActiveKeys(newActiveKeys)
    }, [])

    if (isMobile) {
        return (
            <div className="faq-container">
                <div className="faq-title">Frequent Asked Questions</div>

                <Collapse
                    items={displayFaqs}
                    bordered={false}
                    className="faq-collapse"
                    expandIconPosition="end"
                    onChange={handleFaqChange}
                    activeKey={activeKeys}
                    expandIcon={({ isActive }) => (
                        <svg
                            width="10"
                            height="6"
                            viewBox="0 0 10 6"
                            style={{
                                transform: `rotate(${isActive ? 180 : 0}deg)`,
                                transition: 'transform 0.3s',
                            }}
                        >
                            <path
                                d="M1.175 0.158203L5 3.97487L8.825 0.158203L10 1.33321L5 6.3332L0 1.33321L1.175 0.158203Z"
                                fill="currentColor"
                            />
                        </svg>
                    )}
                />

                {!hideMoreButton && (
                    <button
                        className="more-faqs-button"
                        onClick={handleClickMoreFaqs}
                    >
                        {showMore ? 'Close' : 'More FAQS'}
                    </button>
                )}
            </div>
        )
    }

    return (
        <div className="faq-container">
            <div className="faq-title">Frequent Asked Questions</div>

            <Collapse
                items={displayFaqs}
                bordered={false}
                className="faq-collapse"
                expandIconPosition="end"
                onChange={handleFaqChange}
                activeKey={activeKeys}
                expandIcon={({ isActive }) => (
                    <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        style={{
                            transform: `rotate(${isActive ? 180 : 0}deg)`,
                            transition: 'transform 0.3s',
                        }}
                    >
                        <path
                            d="M1.175 0.158203L5 3.97487L8.825 0.158203L10 1.33321L5 6.3332L0 1.33321L1.175 0.158203Z"
                            fill="currentColor"
                        />
                    </svg>
                )}
            />

            {!hideMoreButton && (
                <button
                    className="more-faqs-button"
                    onClick={handleClickMoreFaqs}
                >
                    {showMore ? 'Close' : 'More FAQS'}
                </button>
            )}
        </div>
    )
}
